import React, { FC, HTMLAttributes } from 'react';

import classNames from '../../helpers/classNames';
import { formatCurrency } from '../../helpers/formatCurrency';
import useTranslate from '../../hooks/useTranslate';

interface FormattedCurrencyProps extends HTMLAttributes<HTMLSpanElement> {
  value: number;
  name: string;
}

const FormattedCurrency: FC<FormattedCurrencyProps> = props => {
  const { value, name, className, ...rest } = props;
  const { activeLanguage } = useTranslate();

  return (
    <span className={classNames(className, 'text-nowrap')} {...rest}>
      {formatCurrency(name, value, activeLanguage.code)}
    </span>
  );
};

export default FormattedCurrency;
